import React from 'react';
import Carousel from '../components/Carousel/Carousel';
import Card from '../components/Cards/Cards';
import cardData from "../data/Carddata";
import { Row, Col } from "reactstrap";

class Home extends React.Component {
    render(){
        return(
            <div>
                <Carousel/>
                <br></br>
                <h1 className="H1">Our Services</h1>
                <div className="container">
                    <Row>
                        {cardData.map((value, index)=>{
                            return (
                                <Col md={4} key={index}>        
                                    <Card         
                                        imgsrc={value.imgsrc}        
                                        title={value.title}       
                                        content={value.content}
                                        path={value.path}
                                        id={value.id}
                                    />  
                                </Col>
                            );
                        })}               
                    </Row>
                </div> 
            </div>
        )
    }
}

export default Home;